import { FC, ReactNode } from 'react';
import { Popover, SxProps, Theme } from '@mui/material';

interface FilterPopoverProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  children: ReactNode;
  width?: string | number;
  height?: string | number;
  bgColor?: string;
  borderColor?: string;
  sx?: SxProps<Theme>;
}

const FilterPopover: FC<FilterPopoverProps> = ({
  open,
  anchorEl,
  onClose,
  children,
  width = '320px',
  height = 'fit-content',
  bgColor = 'white',
  sx = {},
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      PaperProps={{
        sx: {
          width,
          height,
          backgroundColor: bgColor,
          border: '1px solid var(--border)',
          borderRadius: 5,
          p: 2,
          mt: 1,
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          ...sx,
        },
      }}
    >
      {children}
    </Popover>
  );
};

export default FilterPopover;
